import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bij-koninklijke-beschikking-hofleverancier.png")